import { scrollToTop } from '../../utils/dom-utils';

export const init = ($buttons) => {
  $buttons.forEach(($button) => {
    $button.addEventListener('click', () => {
      scrollToTop();
    });
  });
};
